import React, { useEffect, useState } from 'react';
import { Form, Card, Tag, Input, Space } from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllBatches
  //   createWastage,
  //   getPastContainerDetails
} from '../../redux/slice';
import CustomTable from 'common/Content/CustomTable';
import useServerPagination from '@/hooks/useServerPagination';
import moment from 'moment';
import CustomButton from '@/common/CustomButton';
import { history } from 'app/history';
import { getLoggedInUser, getRoles } from 'utilities/helpers';
import Layout from '@/common/Layout';
import { useLocation } from 'react-router-dom';
import { EyeOutlined } from '@ant-design/icons';
import DeactivateTrfModal from '../DeactivateTrfModal';
import {
  BATCH_STATUS,
  LC_STATUS,
  isRequestOpen
} from '@/common/Utils/batchStatus';

const { Search } = Input;

const QAListpage = () => {
  const [form] = Form.useForm();
  const { user } = getLoggedInUser();
  const { SuperadminQCdata } = getRoles('Quality Control');
  const { batchdetails, pagination } = useSelector((state) => state.qaapproval);

  const searchParam = useLocation().search;
  const searchParams = new URLSearchParams(searchParam);

  const { page, pageSize, onChange, reset } = useServerPagination();
  const [search, setSearch] = useState('');
  const [batches, setBatches] = useState('');
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  /* Batch whose test-request history the View modal is showing. */
  const [cyclesBatchId, setCyclesBatchId] = useState(null);
  const [allowedMaterialId, setAllowedMaterialId] = useState(null);

  console.log(batchdetails);
  const dispatch = useDispatch();
  useEffect(() => {
    handleGetAllWastageDetails();
  }, [page, pageSize, search]);

  const handleGetAllWastageDetails = () => {
    const payload = { page, per_page: pageSize, status: 'Quarantine', search };
    dispatch(getAllBatches(payload)).then((response) => {
      if (response?.payload.success) {
        setBatches(response?.payload?.data);
      }
    });
  };

  const handleChange = (e) => {
    setSearch(e.target.value);
    reset();
  };

  /* The two status vocabularies, pulled out of the columns array so the LC tab
     can show BOTH. They were previously one inline ternary that rendered the
     batch status on some tabs and the clearance status on others, under a single
     unlabelled "Status" heading. */
  const renderBatchStatus = (status) =>
    (
      <Tag
        color={
          status === BATCH_STATUS.UNDER_SAMPLING
            ? '#007bff'
            : status === BATCH_STATUS.APPROVED
            ? '#28a745'
            : status === BATCH_STATUS.EXPIRED
            ? '#dc3545'
            : status === BATCH_STATUS.PARTIALLY_ID_APPROVED
            ? '#00ffc8ff'
            : status === BATCH_STATUS.UNDER_TEST
            ? '#343a40'
            : '#FF9800'
        }
      >
        {status?.toUpperCase()}
      </Tag>
    ) || 'NA';

  const renderLcStatus = (lc_status) =>
    (
      <Tag
        color={
          lc_status === LC_STATUS.WH_PENDING
            ? '#007bff'
            : lc_status === LC_STATUS.QA_APPROVED
            ? '#28a745'
            : lc_status === 'LC Approved'
            ? '#28a745'
            : lc_status === 'Rejected'
            ? '#dc3545'
            : lc_status === LC_STATUS.QA_PENDING
            ? '#17a2b8'
            : lc_status === BATCH_STATUS.UNDER_TEST
            ? '#343a40'
            : '#FF9800'
        }
      >
        {lc_status?.toUpperCase()}
      </Tag>
    ) || 'NA';

  const columns = [
    {
      title: 'Batch Number',
      dataIndex: 'inhouse_batch_number',
      key: 'inhouse_batch_number',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return searchParams.get('type') == 'test_requests' ? (
          <a
            href={`test_request_form?id=${record?.id}`}
            onClick={(e) => handleLinkClick(e, record)}
          >
            {text}
          </a>
        ) : searchParams.get('type') == 'lc_sampling' &&
          (user?.role == 'user' || user?.role == 'qc_initiator') &&
          record?.lc_status === LC_STATUS.QA_PENDING ? (
          text
        ) : searchParams.get('type') == 'lc_sampling' &&
          user?.role == 'qc_initiator' ? (
          <a
            href={`qc-create-checklist/${record?.id}?type=sampling`}
            onClick={(e) => handleLinkClick(e, record)}
          >
            {text}
          </a>
        ) : searchParams.get('type') == 'lc_sampling' ? (
          <a
            href={`create-checklist/${record?.id}?type=sampling`}
            onClick={(e) => handleLinkClick(e, record)}
          >
            {text}
          </a>
        ) : user?.level == 3 || SuperadminQCdata?.[0]?.level == 3 ? (
          <a
            href={`qc-approval?id=${record?.id}`}
            onClick={(e) => handleLinkClick(e, record)}
          >
            {text}
          </a>
        ) : (
          text
        );
      }
    },
    {
      title: 'Material Code',
      dataIndex: 'code',
      key: 'code',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.material?.code || 'NA';
      }
    },
    {
      title: 'Material Name',
      dataIndex: 'material_name',
      key: 'material_name',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.material?.name || 'NA';
      }
    },
    {
      title: 'Quantity',
      dataIndex: 'received_quantity',
      key: 'received_quantity',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.received_quantity || 'NA';
      }
    },
    {
      /* Labelled explicitly. On the LC tab this column shows the CLEARANCE
         status; everywhere else it shows the BATCH status. Calling both of them
         "Status" meant the same column heading described two different things
         depending on the tab - and, because batch.controller.js filters the LC
         list by lc_status for qc_initiator and by qc_status for everyone else,
         depending on who was logged in. */
      title: searchParams.get('type') == 'lc_sampling' ? 'LC Status' : 'Status',
      dataIndex:
        searchParams.get('type') == 'lc_sampling' ? 'lc_status' : 'status',
      key: 'status',
      ellipsis: true,
      width: '100px',
      render: (_, record) =>
        searchParams.get('type') == 'lc_sampling'
          ? renderLcStatus(record?.lc_status)
          : renderBatchStatus(record?.status)
    },
    /* The LC tab shows the batch status alongside it. Knowing a clearance is
       approved is only half the picture without knowing whether the batch is
       Under Sampling, back in Quarantine for a new cycle, or already Approved.
       The data is already fetched - batch.controller.js includes
       line_clearance_batch on this query - so this costs nothing. */
    searchParams.get('type') == 'lc_sampling' && {
      title: 'Batch Status',
      dataIndex: 'status',
      key: 'batch_status',
      ellipsis: true,
      width: '100px',
      render: (_, record) => renderBatchStatus(record?.status)
    },
    /* How many test cycles this batch has run, and which one (if any) is still
       open. A batch can only have one open request at a time, so the warehouse
       can see from the list whether raising the next cycle will be blocked -
       without clicking into the batch to find out. */
    searchParams.get('type') !== 'lc_sampling' && {
      title: 'Cycles',
      key: 'cycles',
      align: 'center',
      width: '70px',
      render: (_, record) => record?.test_requests?.length || '—'
    },
    searchParams.get('type') !== 'lc_sampling' && {
      title: 'Test Request',
      key: 'open_request',
      ellipsis: true,
      width: '150px',
      render: (_, record) => {
        const open = (record?.test_requests || []).find((t) =>
          isRequestOpen(t)
        );
        if (open) {
          return (
            <Tag color="#007bff">
              {`#${open?.cycle_no || '?'} ${(
                open?.request_status || ''
              ).toUpperCase()}`}
            </Tag>
          );
        }
        /* No OPEN request. Either every cycle is closed, or the rows predate
           cycle tracking (request_status NULL) and are never treated as open. */
        return record?.test_requests?.length ? (
          <Tag color="#6c757d">NONE OPEN</Tag>
        ) : (
          '—'
        );
      }
    },
    searchParams.get('type') !== 'lc_sampling' && {
      title: 'Type',
      dataIndex: 'is_code_transfer',
      key: 'is_code_transfer',
      ellipsis: true,
      width: '100px',
      render: (text) => {
        return (
          (
            <Tag ghost color={text ? 'processing' : 'default'}>
              {text ? 'Code to Code' : 'General'}
            </Tag>
          ) || 'NA'
        );
      }
    },
    searchParams.get('type') !== 'lc_sampling' && {
      title: 'Status Updated On',
      dataIndex: 'approved_on',
      key: 'approved_on',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.status === 'Quarantine'
          ? moment(record?.createdAt).format('DD MMM YYYY')
          : record?.qc_update_logs[0]?.updated_date
          ? moment(record?.qc_update_logs[0]?.updated_date).format(
              'DD MMM YYYY'
            )
          : 'NA';
      }
    },
    /* Present on every tab, including the line-clearance list: the warehouse
       needs to see which cycles a batch has run and which one it is raising a
       clearance for. There it opens read-only — see `readOnly` on the modal. */
    {
      title: 'View',
      dataIndex: 'inhouse_batch_number',
      key: 'inhouse_batch_number',
      align: 'center',
      width: '100px',
      /* Opens the batch's test-request history rather than navigating to a
         single historic form.

         The ?type=in_active links this replaced loaded exactly ONE arbitrary
         superseded TRF (batch.controller.js:807-831 includes it with
         where is_active:false and no ordering), so on a batch that has run
         several cycles they showed one of them with no indication that the
         others existed. The modal lists them all and carries the close action.

         The originals, kept for reference:
             searchParams.get('type') == 'test_requests' ? (
               <a href={`test_request_form?id=${record?.id}&type=in_active`}
                  onClick={(e) => handleLinkClick(e, record)}>
                 <EyeOutlined />
               </a>
             ) : (
               <a href={`qc-approval?id=${record?.id}&type=in_active`}
                  onClick={(e) => handleLinkClick(e, record)}>
                 <EyeOutlined />
               </a>
             )

         The level 2/3 gate below is the one that was already on the second
         branch; it is kept so nobody gains a view they did not have. */
      render: (text, record) => {
        const may_view =
          user?.level == 3 ||
          user?.level == 2 ||
          SuperadminQCdata?.[0]?.level == 3 ||
          searchParams.get('type') == 'test_requests';
        return may_view ? (
          <a
            onClick={(e) => {
              e.preventDefault();
              setCyclesBatchId(record?.id);
            }}
          >
            <EyeOutlined />
          </a>
        ) : (
          <EyeOutlined />
        );
      },
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    }
  ].filter(Boolean);

  // Row selection logic - same as first component
  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      console.log('Selection changed:', newSelectedRowKeys, selectedRows);

      // If deselecting all rows, reset everything
      if (newSelectedRowKeys.length === 0) {
        setSelectedRowKeys([]);
        setAllowedMaterialId(null);
        return;
      }

      // Get the current row's material_id from the first selected row
      const firstSelectedRow = selectedRows[0];
      if (!firstSelectedRow) {
        setSelectedRowKeys(newSelectedRowKeys);
        return;
      }

      // Set or get the allowed material_id
      const currentMaterialId =
        allowedMaterialId || firstSelectedRow.material_id;

      // If first selection, set the allowed material_id
      if (allowedMaterialId === null) {
        setAllowedMaterialId(currentMaterialId);
      }

      // Filter selected keys to only include rows with matching material_id
      const filteredKeys = [];
      selectedRows.forEach((row) => {
        if (row.material_id === currentMaterialId) {
          const key = row.id;
          if (key) {
            filteredKeys.push(key);
          }
        }
      });

      console.log('Filtered keys:', filteredKeys);
      setSelectedRowKeys(filteredKeys);
    },

    // getCheckboxProps: (record) => {
    //   // Disable based on specific status conditions (adjust as needed)
    //   if (record.status === 'QA Pending' || record.status === BATCH_STATUS.APPROVED) {
    //     return {
    //       disabled: true,
    //       name: record.name
    //     };
    //   }

    //   // If there's an allowed material_id and this row has a different material_id
    //   if (
    //     allowedMaterialId !== null &&
    //     record.material_id !== allowedMaterialId
    //   ) {
    //     return {
    //       disabled: true,
    //       name: record.name
    //     };
    //   }

    //   return {
    //     disabled: false,
    //     name: record.name
    //   };
    // }
    getCheckboxProps: (record) => {
      // Only enable checkboxes for WH LC Pending status
      if (user?.role === 'qc_initiator') {
        if (record.lc_status !== 'QALC Pending') {
          return {
            disabled: true,
            name: record.name
          };
        }
      } else if (record.lc_status !== 'WH LC Pending') {
        return {
          disabled: true,
          name: record.name
        };
      }

      // If there's an allowed material_id and this row has a different material_id
      if (
        allowedMaterialId !== null &&
        record.material_id !== allowedMaterialId
      ) {
        return {
          disabled: true,
          name: record.name
        };
      }

      return {
        disabled: false,
        name: record.name
      };
    }
  };

  const saveBatchesToLocalStorage = (batchIds) => {
    // If role is qc_initiator, save line_clearance_batches id instead of batch ids
    if (user?.role === 'qc_initiator') {
      // Find the selected batches from the batches array
      const selectedBatches = batches.filter((batch) =>
        batchIds.includes(batch.id)
      );

      // Extract line_clearance_batches ids from selected batches
      const lineClearanceIds = selectedBatches
        .map((batch) => batch.line_clearance_batches?.[0]?.id)
        .filter((id) => id !== undefined && id !== null);

      // Save line_clearance_batches ids to localStorage
      localStorage.removeItem('batches');
      if (lineClearanceIds.length > 0) {
        localStorage.setItem('batches', JSON.stringify(lineClearanceIds));
      }
    } else {
      // For other roles, save batch ids as before
      localStorage.removeItem('batches');
      // If batchIds is an array, convert to comma-separated string
      const batchIdsString = Array.isArray(batchIds)
        ? batchIds.join(',')
        : batchIds;
      localStorage.setItem('batches', batchIdsString);
    }
  };

  const handleCampaign = (batchIds) => {
    saveBatchesToLocalStorage(batchIds);

    // Navigate based on role
    if (user?.role === 'qc_initiator') {
      history.push(`/qc-create-checklist/${batchIds[0]}?type=sampling`, {});
    } else {
      history.push(`/create-checklist/${batchIds[0]}?type=sampling`, {});
    }
  };

  const handleLinkClick = (e, record) => {
    // Save the single batch to localStorage
    saveBatchesToLocalStorage([record.id]);
  };

  console.log(allowedMaterialId, selectedRowKeys, 'allowedMaterialId');

  return (
    <Layout sider={false}>
      <Form form={form} layout="vertical">
        <Card
          title={
            <span>
              {searchParams.get('type') == 'test_requests'
                ? 'Test Request Forms'
                : 'Batches List'}
            </span>
          }
          className={`${styles.cardStyles_approver}`}
          extra={
            <Space>
              <Search
                onChange={(e) => handleChange(e)}
                className={`w-100 ${styles.searchbar}`}
                justify="start"
                align="start"
                placeholder="Search by Batch number"
              />
            </Space>
          }
        >
          <div className={`${styles.table_container}`}>
            <CustomTable
              columns={columns}
              rowSelection={
                searchParams.get('type') !== 'test_requests' &&
                searchParams.get('type') !== 'batches'
                  ? rowSelection
                  : ''
              }
              rowKey="id"
              showPaginationMeta
              pagination={{
                size: 'small',
                total: pagination?.total_records || 0,
                current: page,
                pageSize,
                onChange
              }}
              dataSource={batches}
            />
          </div>
        </Card>
        <br />
        <FormItem className="text-center">
          <Space>
            <CustomButton
              htmlType="button"
              type="primary"
              onClick={() => handleCampaign(selectedRowKeys)}
              disabled={selectedRowKeys?.length ? false : true}
            >
              Initiate Line Clearance
            </CustomButton>
            <CustomButton
              className={styles.inwardButton}
              onClick={() => history.back()}
              type="primary"
            >
              Back to Home
            </CustomButton>
          </Space>
        </FormItem>
      </Form>
      <DeactivateTrfModal
        visible={!!cyclesBatchId}
        batchDetailsId={cyclesBatchId}
        onCancel={() => setCyclesBatchId(null)}
        onChanged={() => handleGetAllWastageDetails()}
        readOnly={searchParams.get('type') == 'lc_sampling'}
      />
    </Layout>
  );
};
export default QAListpage;
